// extracted by mini-css-extract-plugin
module.exports = {"outerWrapper":"addToCartButtons_outerWrapper__KlgNa","wrapper":"addToCartButtons_wrapper__SewYM","center":"addToCartButtons_center__6kwIZ","error":"addToCartButtons_error__zWZfZ"};